import {useForm} from "react-hook-form"
import {Category, ContactManager} from "dto/category/category"
import {DialogBox, DialogBoxBody, DialogBoxFooter} from "common/DialogBox"
import {useEffect} from "react"
import {FormErrorBox} from "common/FormErrorBox"

type FormProps = {
    show: boolean
    close: () => void
    category?: Category
    onSubmit: (value: CategoryInput) => void
}

export type CategoryInput = {
    name: string
    contactManager?: ContactManager
}
export default function LocationCategoryForm({show, close, category, onSubmit}: FormProps) {
    const {register, handleSubmit, formState: {errors}, setValue, getValues, watch} = useForm<CategoryInput>()
    const title = category ? "카테고리 수정하기" : "카테고리 등록하기"
    useEffect(() => {
        if (category === undefined) return
        setValue("name", category?.name)
        setValue("contactManager", category?.contactManager)
    }, [category])
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <DialogBox show={show} close={close} title={title} color={"link"}>
                <DialogBoxBody>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">카테고리명</div>
                            <div className="column">
                                <input
                                    {...register("name", {required: "카테고리명을 입력해주세요"})}
                                    className="input" type="text" placeholder="카테고리명"/>
                                <FormErrorBox error={errors.name}/>
                            </div>
                        </div>
                    </div>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">매니저 정보</div>
                            <div className="column">
                                <input
                                    {...register("contactManager.managerName")}
                                    className="input" type="text" placeholder="매니저명"/>
                                <FormErrorBox error={errors.contactManager?.managerName}/>
                            </div>
                            <div className="column">
                                <input
                                    {...register("contactManager.contactNumber")}
                                    className="input" type="text" placeholder="매니저 전화번호"/>
                                <FormErrorBox error={errors.contactManager?.contactNumber}/>
                            </div>
                        </div>
                    </div>
                    {/*<div className="hr-line-dashed"/>*/}
                </DialogBoxBody>
                <DialogBoxFooter>
                    <button type="submit" className="button is-success">{category ? "카테고리수정" : "카테고리저장"}</button>
                    <div className="button" onClick={close}>취소</div>
                </DialogBoxFooter>
            </DialogBox>
        </form>
    )
}